
export default {
  /**
   * @type {String}     Constant for type of contact us request for Add Freelancers.
   */
  UPGRADE_REQUEST_ADD_FREELANCERS: 'freelancers_upgrade',

  /**
   * @type {String}     Constant for type of contact us request for credits.
   */
  UPGRADE_REQUEST_CREDITS: 'credits_upgrade',

  /**
   * @type {String}     Constant for type of contact us request for pricing.
   */
  UPGRADE_REQUEST_PRICING: 'pricing_upgrade',

  /**
   * @type {String}     Constant for type of contact us request for reports.
   */
  UPGRADE_REQUEST_REPORTS: 'reports_upgrade',

  /**
   * @type {String}     Constant for type of contact us request for user search.
   */
  UPGRADE_REQUEST_SEARCH: 'search_upgrade'
};
